module.exports = __webpack_public_path__ + "static/media/cattle-drones-from-elvis-credit-REUTERS.fb228aaf.jpg";